.CollapsibleContent {
  overflow: hidden;
}
.CollapsibleContent[data-state='open'] {
  animation: slideDown 200ms ease-out;
}
.CollapsibleContent[data-state='closed'] {
  animation: slideUp 200ms ease-out;
}

@keyframes slideDown {
  from {
    height: 0;
  }
  to {
    height: var(--radix-collapsible-content-height);
  }
}

@keyframes slideUp {
  from {
    height: var(--radix-collapsible-content-height);
  }
  to {
    height: 0;
  }
}

.badge {
  color: var(--tractie-color-content-default-inverse);
  min-width: 20px;
  padding: 2px 4px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 11px;
  border-radius: 11px;
  border: 1px solid var(--tractie-color-content-default-inverse);
  cursor: pointer;
  background: var(--tractie-color-background-brand-secondary);
}
